import { rotate, flip, addToRecentColors, setEditorPreview } from "./helpers";

import { iconEditorInitialState, iconTransformsInitialState } from "./state";

const iconEditorReducer = (state = iconEditorInitialState, action) => {
    const { iconId, color } = action;

    let newState = { ...state };

    switch (action.type) {
        case "SET_TOKEN":
            newState = {
                ...newState,
                token: action.token
            };

            break;

        case "SET_CURRENT_ICON":
            newState = {
                ...newState,
                currentIconId: action.iconId,
                [action.iconId]: iconTransformsInitialState
            };

            break;

        case "FETCH_PREVIEW_IMAGE":
            newState = {
                ...newState,
                fetchingPreviewImage: true
            };

            break;

        case "FETCH_PREVIEW_IMAGE_SUCCESS":
            const { previewImageHtml } = action;

            newState = setEditorPreview({
                state,
                iconId: state.currentIconId,
                editorPreviewHtml: previewImageHtml
            });

            newState = {
                ...newState,
                fetchingPreviewImage: false
            };
            break;

        case "FETCH_PREVIEW_IMAGE_FAILURE":
            const { tokenIsExpired } = action;

            newState = {
                ...newState,
                fetchingPreviewImage: false,
                fetchingToken: tokenIsExpired
            };

            break;

        case "FETCH_PREVIEW_IMAGE_TOKEN":
            newState = {
                ...newState,
                fetchingToken: true
            };

            break;

        case "FETCH_PREVIEW_IMAGE_TOKEN_SUCCESS":
            const { token } = action;
            newState = {
                ...newState,
                fetchingToken: false,
                token,
                fetchingPreviewImage: true
            };

            break;

        case "FETCH_PREVIEW_IMAGE_TOKEN_FAILURE":
            newState = {
                ...newState,
                fetchingToken: false
            };

            break;

        // delete this case later bc it's about to become obsolete
        case "SET_EDITOR_PREVIEW":
            newState = setEditorPreview({
                state,
                iconId: state.currentIconId,
                editorPreviewHtml: action.editorPreviewHtml
            });

            break;

        case "ROTATE_CW":
            newState = rotate({ state, iconId, direction: "cw" });
            newState.editCount = state.editCount + 1;

            break;

        case "ROTATE_CCW":
            newState = rotate({ state, iconId, direction: "ccw" });
            newState.editCount = state.editCount + 1;

            break;

        case "FLIP_X":
            newState = flip({ state, axis: "x", iconId });
            newState.editCount = state.editCount + 1;

            break;

        case "FLIP_Y":
            newState = flip({ state, axis: "y", iconId });
            newState.editCount = state.editCount + 1;

            break;

        case "ADD_TO_RECENT_ICON_COLORS":
            newState = addToRecentColors({
                isBackgroundColor: false,
                colorToAdd: state.iconColors.activeColor,
                state: { ...state }
            });
            newState.editCount = state.editCount + 1;

            break;

        case "ADD_TO_RECENT_BACKGROUND_COLORS":
            newState = addToRecentColors({
                isBackgroundColor: true,
                colorToAdd: state.backgroundColors.activeColor,
                state: { ...state }
            });
            newState.editCount = state.editCount + 1;

            break;

        case "SET_ACTIVE_ICON_COLOR":
            newState = {
                ...state,
                editCount: state.editCount + 1,
                iconColors: {
                    ...state.iconColors,
                    activeColor: color
                }
            };

            break;

        case "SET_ACTIVE_BACKGROUND_COLOR":
            newState = {
                ...state,
                editCount: state.editCount + 1,
                backgroundColors: {
                    ...state.backgroundColors,
                    activeColor: color
                }
            };

            break;
    }

    return newState;
};

export default iconEditorReducer;
